<template>
  <div>
    <!--首页预览  -->
    <baseBreadcrumb
      :page="$t('message.homePreview')"
      :menu="$t('message.operationAndMaintenance')"
    />
    <div class="body">
      <!-- 首页静态横幅编辑及效果预览。 -->
      <staticBanner />
      <recommend />
      <classifyGoods />
    </div>
  </div>
</template>
<script>
import recommend from "./components/recommend";
import classifyGoods from "./components/classifyGoods";
import staticBanner from './components/staticBanner'
export default {
  components: {
    staticBanner,
    recommend,
    classifyGoods,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>
